import { Response } from "express";

import { IResultHandler } from "./IResultHandler";

export type IActionResult = (req: Express.Request, res: Response) => Promise<void>;

export class CustomActionResultHandler implements IResultHandler {
    public async processResult(result: IActionResult, req: Express.Request, res: Response): Promise<void> {
        await result(req, res);
    }
}
